import { render, staticRenderFns } from "./portal-acceso-comercio.vue?vue&type=template&id=76293e7d&scoped=true&"
import script from "./portal-acceso-comercio.vue?vue&type=script&lang=js&"
export * from "./portal-acceso-comercio.vue?vue&type=script&lang=js&"
import style0 from "./portal-acceso-comercio.vue?vue&type=style&index=0&id=76293e7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76293e7d",
  null
  
)

export default component.exports